export const DEFAULT_TICK_HEIGHT = 50;
export const DEFAULT_TICK_WIDTH = 150;
export const DEFAULT_TICK_WIDTH_GANTT = 200;

/** Returns the number of ticks for a given height */
export function getVerticalNumTicks(height: number) {
  return Math.ceil(height / DEFAULT_TICK_HEIGHT);
}

/** Returns the number of ticks for a given width */
export function getHorizontalNumTicks(width: number) {
  return Math.ceil(width / DEFAULT_TICK_WIDTH);
}

/** Returns the number of ticks for a given width for a time axis */
export function getHorizontalTimeAxisNumTicks(width: number) {
  return Math.min(Math.max(Math.round(width / 130), 2), 20);
}

/** Returns the number of ticks for a given width for a gantt chart time axis */
export function getGanttHorizontalTimeAxisNumTicks(width: number) {
  return Math.floor(width / DEFAULT_TICK_WIDTH_GANTT) || 1;
}
